import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux' 
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { clearUserUpdateMsg } from '../actions/profileAction'
import { addTagsAction,clearMasterAddMsg, updateTagsAction, deleteMasterAction } from '../actions/masterAction'
import MasterEditPopup from './masterEditPopup'

import MasterTrashPopup from './masterTrashPopup';

import AddTag from './addTag';


const { SearchBar } = Search;



class TagsList extends Component {

   constructor(props){

      super(props)
this.state = {
  editData:'',
  trashId:'',
  isOpentrash:false,
  isOpen:false,
  currentPage: 1,
  perPage: 10
}

this.formatAction = this.formatAction.bind(this)
this.formatSlno = this.formatSlno.bind(this)
this.formatStatus = this.formatStatus.bind(this)
this.saveTag = this.saveTag.bind(this)
this.updateTag = this.updateTag.bind(this)
this.trashTag = this.trashTag.bind(this)
this.editTag = this.editTag.bind(this)
this.deleteTag = this.deleteTag.bind(this)

this.closeModal = this.closeModal.bind(this)
this.onPageChange = this.onPageChange.bind(this)
this.onSizePerPageChange = this.onSizePerPageChange.bind(this)
   }

   onPageChange = (page, perPage) => {

 

    this.setState({
      currentPage: page,
      perPage: perPage
    })


  };
  onSizePerPageChange = ( perPage, page) => {

 

    this.setState({
      currentPage: page,
      perPage: perPage
    })


  };

   formatAction=(row)=>{

    let sendData = {name:row.tag_name, description: row.tag_desc, id: row.id, status:row.tag_active}

      return (
     <span> <a title="edit" onClick ={(e)=>{this.editTag(e,sendData);}} href="#"> <i className="fa fa-pencil"></i></a>{' '}&nbsp;&nbsp;
     {row.tag_active?<a title="Suspend" onClick ={(e)=>{this.deleteTag(e,row.id);}} href="#"> <i className="fa fa-ban"></i></a>:''}
     
     </span>
      )
   }
   formatSlno = (cell, row, rowIndex, ) => {
    const { currentPage, perPage } = this.state

   let slNo=rowIndex+1

  
    slNo = (currentPage * perPage + slNo) - perPage
 
   
     

    
    return slNo


  }
   formatStatus=(cell)=>{

if(cell ===0){
  return "Suspended"
}else if (cell ===1){
  return "Active"
}

    

    
   }
 
   saveTag=(formData)=>{

    this.props.addTag(formData)
   }


   updateTag=(formData)=>{

      this.props.updateTag(formData)


    setTimeout(() => {
      this.setState({
        editData:{},
        isOpen:false
      })
    }, 1000);


   }
  
   trashTag=(id)=>{

    this.props.deleteTagFn(id,'tag')

    setTimeout(() => {
      this.setState({
        trashId:'',
        isOpentrash:false
      })
    }, 1000);


   }
   editTag=(e,data)=>{

    
e.preventDefault()
    this.setState({
      editData:data,
      isOpen:true
    })
   }
   deleteTag=(e,id)=>{

    
e.preventDefault()
    this.setState({
      trashId:id,
      isOpentrash:true
    })
   }
   closeModal=()=>{

    this.setState({
      editData:{},
      isOpen:false,
      trashId:'',
      isOpentrash:false
    })
   }

 


  componentDidMount(){



  }

  componentWillReceiveProps(nextProps){



  }
  componentWillUnmount(){

    this.props.clearMasterAddMsg()
  }
    render(){
      const columns = [{
         dataField: 'id',
         text: '#',
         formatter: this.formatSlno

       }, {
         dataField: 'tag_name',
         text: 'Tag'
       },{
        dataField: 'tag_desc',
        text: 'Description'
      },{
        dataField: 'tag_active',
        text: 'Status',
        formatter: (cell) => this.formatStatus(cell)

      },
        
        {
         dataField: 'id',
         text: 'Action',
         formatter: (cell, row) => this.formatAction(row)
       },
      
      ];

      const {tags} = this.props
      const {editData, isOpen, isOpentrash, trashId} = this.state
      const options = {
        onPageChange: this.onPageChange,
        onSizePerPageChange: this.onSizePerPageChange,
  
      };
return(
  

  <div>

    <AddTag saveTag={this.saveTag} />

{tags&&<ToolkitProvider
 bootstrap4 keyField='id'
 data={ tags }
 columns={ columns } 

 search
>
{props =>
(<div>
<SearchBar { ...props.searchProps } />
        <hr />
<BootstrapTable 
classes="table-responsive"
 { ...props.baseProps }  pagination={ paginationFactory(options) }
/>
</div>)}

 </ToolkitProvider>}

<MasterEditPopup  isOpen={isOpen} editData={editData}  closeModal={this.closeModal} onUpdated={this.updateTag} key={editData.id}  />


<MasterTrashPopup isOpentrash={isOpentrash} trashId={trashId} closeModal={this.closeModal} onDelete={this.trashTag} key={trashId}  />   </div>


          
        ) }

}

const mapStateToProps = state => ({
 
  tags: state.tagsMasterReducer.tags,

 
 })
 const mapDispatchToProps = dispatch => ({
  
  clearMasterAddMsg:()=>dispatch(clearMasterAddMsg()),
  addTag:(formData)=>dispatch(addTagsAction(formData)),
  updateTag:(formData)=>dispatch(updateTagsAction(formData)),
  deleteTagFn:(id,type)=>dispatch(deleteMasterAction(id,type)),

 
 
 })
 export default connect(mapStateToProps, mapDispatchToProps)(TagsList)